import {
  Button,
  Dialog,
  Grid,
  RadioGroup,
  FormControlLabel,
  Radio,
  MenuItem,
  Box,
  Snackbar,
  Alert,
  Typography,
  TextField,
} from "@mui/material";
import { useState } from "react";
import axios from "axios";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { useNavigate } from "react-router-dom";

import paperBackFirstImg from "../../../assets/images/masks/paper-back-1.svg";
import paperBackSecondImg from "../../../assets/images/masks/paper-back-2.svg";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const categoryOptions = [
  "residenceChangeRequest",
  "roomChangeRequest",
  "productRequest",
  "compensationRequest",
  "missedProduct",
  "cancellationRequest",
  "refundItem",
  "referenceLetterRequest",
  "portalPaymentIssue",
  "generalResidenceProblems",
  "other",
];


const NewRequest = ({
  newRequest,
  onClose,
  fetchAllTickets,
  tickets,
  otherRequestControl,
  selectedStudent,
  partnerId,
}) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [priority, setPriority] = useState(0);
  const [file, setFile] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  const lightMode = useSelector((state) => state.mode.lightMode);


  const { student_id, student_name } = selectedStudent || {};

  function handleClose() {
    onClose(undefined);
    setSubject("");
    setDescription("");
    setCategory("");
    setFile(null);
  }

  const handleFileUpload = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  const handleCategoryChange = (e) => {
    const selectedCategory = e.target.value;

    // Kullanıcının seçtiği kategoride açık veya devam eden bir ticket var mı kontrol et
    const existingTicket = tickets.some(
      (ticket) =>
        ticket.category === selectedCategory &&
        (ticket.ticket_status === 0 || ticket.ticket_status === 2)
    );

    if (existingTicket) {
      setCategory("");
      setErrorMessage(
        `You already have an active request for "${selectedCategory}". Please check your tickets.`
      );
    } else {
      setCategory(selectedCategory);
    }
  };
  const navigate = useNavigate();
  const handleSubmit = async () => {
    setLoading(true);

    if (!subject || !description || (!otherRequestControl && !category)) {
      setErrorMessage("Form fields must be filled!");
      return false;
    }
    const formData = new FormData();
    formData.append("api_key", "O0AUQ0KLAD3I71K8YKR82Y6AP");
    formData.append("source", "Partner Portal");
    formData.append("partner_id", partnerId);

    formData.append("student_id", student_id);
    formData.append("student_name", student_name);
    formData.append("subject", subject);
    formData.append("description", description);
    formData.append("environment", "DEV");
    formData.append(
      "category",
      otherRequestControl ? otherRequestControl : category
    );
    formData.append("priority", priority.toString());
    formData.append("source", "Student Portal");
    if (file) {
      formData.append("file[]", file);
    }

    try {
      const response = await axios.post(
        "https://webservice.londonist.co.uk/v1/DMCSaveTicket",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      // fetchAllTickets();
      navigate("/requests");
      handleClose();
    } catch (err) {
      console.error("Error:", err.response?.data || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog maxWidth="sm" open={Boolean(newRequest)} onClose={handleClose}>
      <Grid container width={1} p={{ xs: 2, md: 3, xl: 4 }} spacing={1}>
        <Grid item xs={12}>
          <Typography variant="h5" fontWeight={500} textAlign="center" pb={2}>
            {t("createTicket")} {category}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            required
            disabled={loading}
            label={t("subject")}
            name="subject"
            onChange={(e) => setSubject(e.target.value)}
          />
        </Grid>
        {!otherRequestControl ? (
          <Grid item xs={12}>
            <TextField
              select
              fullWidth
              required
              label={t("category")}
              value={category}
              onChange={handleCategoryChange}
            >
              {categoryOptions.map((cat) => (
                <MenuItem key={cat} value={cat}>
                  {t(cat)}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        ) : null}

        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            disabled={loading}
            minRows={3}
            maxRows={5}
            required
            label={t("description")}
            name="description"
            onChange={(e) => setDescription(e.target.value)}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography textTransform={"capitalize"} variant="subtitle1" fontWeight={500} pb={1}>
            {t("priorityLevel")}
          </Typography>
          <RadioGroup
            row
            value={priority}
            onChange={(e) => setPriority(Number(e.target.value))}
          >
            <FormControlLabel value={0} control={<Radio />} label={t("low")} />
            <FormControlLabel value={1} control={<Radio />} label={t("medium")} />
            <FormControlLabel value={2} control={<Radio />} label={t("high")} />
            {/* <FormControlLabel value={3} control={<Radio />} label="Urgent" /> */}
          </RadioGroup>
        </Grid>

        <Grid item xs={12}>
          <Box
            sx={{
              border: "1px dashed #ccc",
              borderRadius: "8px",
              padding: "16px",
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              "&:hover": {
                borderColor: "primary.main",
                backgroundColor: "rgba(0, 0, 0, 0.03)",
              },
            }}
            component="label"
          >
            <input type="file" hidden onChange={handleFileUpload} />
            <UploadFileIcon
              sx={{
                fontSize: 40,
                color: file ? "primary.main" : "text.secondary",
                mr: 2,
              }}
            />
            <Box>
              <Typography variant="body1" color="textSecondary">
                {file ? t("changeFile") : t("clickToUploadFile")}
              </Typography>
              {file && (
                <Typography
                  variant="body2"
                  color="textPrimary"
                  sx={{ wordBreak: "break-word" }}
                >
                  {file.name}
                </Typography>
              )}
            </Box>
          </Box>
        </Grid>

        <Grid item xs={6}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleClose}
            disabled={loading}
          >
            <Typography variant="body1" color="#fff">
              {t("close")}
            </Typography>
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            variant="contained"
            color="secondary"
            fullWidth
            onClick={handleSubmit}
            disabled={
              loading ||
              !subject ||
              !description ||
              (!otherRequestControl && !category)
            }
          >
            <Typography variant="body1" color="#fff">
              {t("create")}
            </Typography>
          </Button>
        </Grid>
      </Grid>

      <Snackbar
        open={Boolean(errorMessage)}
        autoHideDuration={4000}
        onClose={() => setErrorMessage(null)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }} // Yukarıda ve ortalı konumlandırma
      >
        <Alert severity="error" onClose={() => setErrorMessage(null)}>
          {errorMessage}
        </Alert>
      </Snackbar>
    </Dialog>
  );
};

export default NewRequest;
